module.exports = __webpack_public_path__ + "img/mw.0e7b6356.svg";